import { render, staticRenderFns } from "./Minimal.vue?vue&type=template&id=e8efdb00&scoped=true"
import script from "./Minimal.vue?vue&type=script&lang=js"
export * from "./Minimal.vue?vue&type=script&lang=js"
import style0 from "./Minimal.vue?vue&type=style&index=0&id=e8efdb00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8efdb00",
  null
  
)

export default component.exports